import { useState, useEffect } from "react";

export function useAttribution() {
  const [attribution, setAttribution] = useState({});
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setAttribution({
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: params.get("utm_content") || "",
      utm_term: params.get("utm_term") || "",
      fbclid: params.get("fbclid") || "",
      gclid: params.get("gclid") || "",
      pageUrl: window.location.href,
      referrer: document.referrer || "",
      timestamp: new Date().toISOString(),
    });
  }, []);
  return attribution;
}
